import React from 'react'
import View from './view.js'
import { useDataValue } from 'Simple/Data.js'

export default function Logic(props) {
  let selected_action_type = useDataValue({
    context: 'event_action',
    path: 'type',
    viewPath: props.viewPath,
  })

  let action_types = useDataValue({
    context: 'action_types',
    viewPath: props.viewPath,
  })

  let text = action_types.find(at => at.id === selected_action_type)?.text || ''

  return <View {...props} text={text} />
}
